import { network } from 'services/network';

import { QueryResponse } from 'api/endPoints/GetReportAccessStatus';

export const setReportAccessStatus = (params: QueryParams) => {
    return network.post<QueryResponse>('api/bo/reporting/setReportAccessStatus', params).then((response) => {
        return response.data;
    });
};

export interface QueryParams {
    reportId: number;
    reportAccessStatus: {
        allUsersAccess: boolean;
        notifyAllUsersOnUpload: boolean;
        userAccessStatusList: UserAccessStatus[];
    };
    tags: { id: number }[];
}

export interface UserAccessStatus {
    userName: string;
    canHaveAccess: boolean;
    hasAccess: boolean;
    notifyOnUpload: boolean;
}
